<ca-header [srcLogo]="pathLogo" CombinedOptions>
  <ul class="ca-header__nav ajustar-menu" *ngIf="menuItems?.length">
    <ng-container *ngFor="let item of menuItems">
      <li *ngIf="!item.nodosHijos?.length" (click)="clickMenuItem(item.txtPath)">{{item.txtTitulo | translate}}</li>
      <ng-container *ngIf="item.nodosHijos?.length">
        <li ca-breadcrumb-item value="{{item.nodosHijos}}">
          <button [caMenuTriggerFor]="menuItem" [closeAllOnOpen]="true">{{item.txtTitulo | translate}}
            <span class="material-icons">arrow_drop_down</span>
          </button>
          <ca-menu #menuItem="caMenu">
            <ng-container *ngFor="let subItem of item.nodosHijos; let i = index">
              <ca-menu-item (selected)="clickMenuItem(subItem.txtPath)"> {{subItem.txtTitulo | translate}}
              </ca-menu-item>
            </ng-container>
          </ca-menu>
        </li>
      </ng-container>
    </ng-container>
  </ul>
  <div class="ca-header__action">
    <button class="button__user" caTooltip="Pulsa para cambiar de tema" [caMenuTriggerFor]="menuThemes"><span
        class="material-icons">format_color_fill</span></button>
    <ca-menu #menuThemes="caMenu">
      <ca-menu-item (selected)="cargarTema('base')"> Tema base </ca-menu-item>
      <ca-menu-item (selected)="cargarTema('umbrela')"> Umbrela </ca-menu-item>
      <ca-menu-item (selected)="cargarTema('mediacion')"> Mediacion </ca-menu-item>
      <ca-menu-item (selected)="cargarTema('helvetia')"> Helvetia </ca-menu-item>
    </ca-menu>
  </div>
  <div class="ca-header__action">
    <button class="button__user" caTooltip="Pulsa sacar pantallazo" (click)="capturarPagina()"><span
        class="material-icons">screenshot_monitor</span></button>
  </div>
  <div class="ca-header__action">
    <app-usuario-conectado></app-usuario-conectado>
  </div>
</ca-header>